import { EncryptStorage } from 'encrypt-storage';

const encryptStorage = new EncryptStorage("RRS@2025ReceiptRecordingSystem", {
    prefix: "RRS",
});

export default encryptStorage;